/**
 * Minimal service-worker registration helper for the seller portal.
 *
 * In production: registers the SW with a cache-busting version key.
 * In development: unregisters any previously-installed SW so HMR works.
 */

const SW_VERSION =
  process.env.REACT_APP_SW_VERSION || `dev-${Date.now()}`;

export function register() {
  if (process.env.NODE_ENV !== "production") {
    unregister();
    return;
  }
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js?v=${encodeURIComponent(SW_VERSION)}`;
    navigator.serviceWorker
      .register(swUrl)
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("SW registration failed:", err);
      });
  });
}

export function unregister() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {
      // Best-effort — ignore.
    });
}
